import { chakra } from "@chakra-ui/react";

// Define styles for various parts of the CardComponent
export const StyledCardWrapper = chakra("div", {
  base: {
    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.05)",
    border: "1px solid #EAECF0",
    borderRadius: "20px",
    overflow: "hidden",
    bg: "white",
    width: "100%",
    maxWidth: "100%",
    minWidth: "275px",
    padding: "16px 24px",
  },
});

export const StyledCardHeader = chakra("div", {
  base: {},
});

export const StyledCardBody = chakra("div", {
  base: {},
});

export const StyledCardFooter = chakra("div", {
  base: {},
});
